<template>
    <div class="block">
        <div>
            <h3 class="text">皇家同花顺</h3>
            <img class="img" src="~images/poker_pap_0_fc.png" alt=""/>
            <img class="img" src="~images/poker_pap_12_fc.png" alt=""/>
            <img class="img" src="~images/poker_pap_11_fc.png" alt=""/>
            <img class="img" src="~images/poker_pap_10_fc.png" alt=""/>
            <img class="img" src="~images/poker_pap_9_fc.png" alt=""/>
            <input-set-value
                    type="number"
                    class="input"
                    :defaultValue="info.royalFlushRatio"
                    :max="info.royalFlushRatioLimit"
                    unit="%"
                    @my-submit="submitFunc($event,'royalFlushRatio')"/>
        </div>
        <div>
            <h3 class="text">同花顺</h3>
            <img class="img" src="~images/poker_pap_25_fc.png" alt=""/>
            <img class="img" src="~images/poker_pap_24_fc.png" alt=""/>
            <img class="img" src="~images/poker_pap_23_fc.png" alt=""/>
            <img class="img" src="~images/poker_pap_22_fc.png" alt=""/>
            <img class="img" src="~images/poker_pap_21_fc.png" alt=""/>
            <input-set-value
                    type="number"
                    class="input"
                    :defaultValue="info.straightFlushRatio"
                    :max="info.straightFlushRatioLimit"
                    unit="%"
                    @my-submit="submitFunc($event,'straightFlushRatio')"/>
        </div>
        <div>
            <h3 class="text">四条</h3>
            <img class="img" src="~images/poker_pap_0_fc.png" alt=""/>
            <img class="img" src="~images/poker_pap_13_fc.png" alt=""/>
            <img class="img" src="~images/poker_pap_26_fc.png" alt=""/>
            <img class="img" src="~images/poker_pap_39_fc.png" alt=""/>
            <img class="img" src="~images/poker_pap_12_fc.png" alt=""/>
            <input-set-value
                    type="number"
                    class="input"
                    :defaultValue="info.fourOfAKindRatio"
                    :max="info.fourOfAKindRatioLimit"
                    unit="%"
                    @my-submit="submitFunc($event,'fourOfAKindRatio')"/>
        </div>
    </div>
</template>
<script>
    import {mapActions} from 'vuex'
    import inputSetValue from '../../../components/inputSetValue'

    export default {
        components: {
            inputSetValue
        },
        props: {
            info: Object
        },
        methods: {
            ...mapActions('jackpot', ['updateJackpotRatio']),
            submitFunc(obj, name) {
                let params = {
                    blindCode:this.info.blindCode,
                    poolId: this.info.childPoolId,
                    royalFlushRatio: this.info.royalFlushRatio,
                    straightFlushRatio: this.info.straightFlushRatio,
                    fourOfAKindRatio: this.info.fourOfAKindRatio
                };
                if (params[name] === +obj.value) {
                    obj.cb();
                    return
                }
                params[name] = +obj.value;
                this.updateJackpotRatio(params).then(() => {
                    this.$message.success('修改成功');
                    obj.cb()
                })
            }
        }
    }
</script>
<style lang="scss" scoped>
    .block {
        display: flex;
        justify-content: space-around;
        text-align: center;
        flex-wrap: wrap;
    }

    .text {
        padding: 20px 0 10px;
    }

    .img {
        width: 50px;
        margin-right: 5px;
    }

    .input {
        display: block;
        height: 45px;
        padding: 10px 0;
        font-size: 20px;
    }
</style>